import * as Sentry from '@sentry/react';
import configJson from '../templates/typesense-ui/constants.json';

export default Sentry.init({
  dsn: 'https://c7375f8c3a33187e9c29dd643269b20f@o4509871365881856.ingest.us.sentry.io/4509871401795584',
  sendDefaultPii: true,
  environment: configJson?.env || 'local',
  normalizeDepth: 10,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
});
